import { useContext } from 'react';
import { PermissionContext } from '../contexts/PermissionContext';
import type { PermissionContextValue } from '../contexts/PermissionContext';

export function usePermissions(): PermissionContextValue {
  return useContext(PermissionContext);
}
